import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { isEmpty } from 'lodash';
import { distinctUntilChanged, filter, map, take } from 'rxjs/operators';

import { SiteService } from '../../../core/api/site.service';
import { Cohort, Site } from '../../../shared/models';
import * as fromApp from '../../../store';
import { setSelectedCohortBuyerAndNavigate, updateSiteFailure, updateSiteStep, } from '../../../store/site/site.actions';
import { selectActiveSite } from '../../../store/site/site.selectors';

@Component({
  selector: 'fc-select-offer',
  templateUrl: './select-offer.component.html',
  styleUrls: ['./select-offer.component.scss'],
})
export class SelectOfferComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  id: number;
  activeSite: Site = null;
  availableCohorts: Cohort[] = [];

  selectedCohort: Cohort = null;

  constructor(
    readonly store: Store<fromApp.AppState>,
    readonly route: ActivatedRoute,
    readonly siteService: SiteService,
    readonly router: Router
  ) {
    this.id = +this.route.snapshot.params.id;
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.store.dispatch(
      updateSiteStep({
        id: this.id,
        step: 'Offer Selection',
      })
    );

    this.store
      .select(selectActiveSite)
      .pipe(
        distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
        map(activeSite => {
          if (activeSite) {
            return activeSite;
          } else {
            // this.store.dispatch(setActiveSite({ id: this.id }));
            this.router.navigate([`/site/${this.id}/map-site`]);
          }
        }),
        filter(site => !isEmpty(site)),
        take(1),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(activeSite => {
        this.activeSite = activeSite;
        if (this.activeSite.availableCohorts) {
          this.availableCohorts = this.activeSite.availableCohorts;
          if (this.activeSite.cohort.buyer) {
            this.selectedCohort = this.availableCohorts.find(c => c.buyerId === this.activeSite.cohort.buyerId);
          } else if (this.availableCohorts.length === 1) {
            this.selectedCohort = this.availableCohorts[0];
          }
        }
      });
  }

  selectCohort(cohort: Cohort): void {
    this.selectedCohort = cohort;
  }

  onSubmit(): void {
    this.siteService
      .updateCohort(this.activeSite.id, this.selectedCohort.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        savedSite => {
          this.store.dispatch(setSelectedCohortBuyerAndNavigate({ data: savedSite }));
        },
        error => this.store.dispatch(updateSiteFailure({ error }))
      );
  }
}
